import { ADMIN_ACCESS, MULTI_STATION_ADMIN_ACCESS, NO_ACCESS } from "./constants";
import { formatEmployeeIdForKronos } from "./miscFormatter";
import { getSuperuserAccess, getUserAccessRole } from "./userAccessRetriever";
import { getDefaultUserAccessGiveJobCode } from "./workgroupMapper";

export async function getUserDataFromEmployeeService(data) {
  let [[role, multiStationAdminStationList], [isSuperuser, superuserStationList]] = await Promise.all([
    getUserAccessRole(data),
    getSuperuserAccess(data),
  ]);
  let loggedInUserData;
  if (role === NO_ACCESS) {
    loggedInUserData = {
      isActive: false,
      appRole: role,
      eid: getEmployeeId(data),
      kronosPersonNumber: formatEmployeeIdForKronos(getEmployeeId(data)),
    };
  } else {
    let jobCode = getEmployeeJobCode(data);
    loggedInUserData = {
      isActive: true,
      eid: getEmployeeId(data),
      kronosPersonNumber: formatEmployeeIdForKronos(getEmployeeId(data)),
      firstName: getEmployeeFirstName(data),
      lastName: getEmployeeLastName(data),
      activeStation: getEmployeeActiveStation(data),
      homeStation: getEmployeeHomeStation(data),
      jobCode: jobCode,
      appRole: role,
      defaultAppRole: getDefaultUserAccessGiveJobCode(jobCode),
      isAdmin: isAdmin(role),
      multiStationAdminStationList: multiStationAdminStationList,
      isSuperuser: isSuperuser,
      superuserStationList: superuserStationList,
      ftpt: getFtPt(data),
      phoneNumber: getPhoneNumber(data),
      v: getV(data),
      classificationDate: getClassificationDate(data),
      contractDate: getContractDate(data),
      wnSliSeniorityDate: getWnSliSeniorityDate(data),
      flAtlSeniorityDate: getFlAtlSeniorityDate(data),
      dualSeniorityDate: getDualSeniorityDate(data),
      seniorityDate: getSeniorityDate(data),
      hireDate: getHireDate(data),
      birthDate: getBirthDate(data),
      createdAt: getCreatedAt(data),
      createdBy: getCreatedBy(data),
      comments: getComments(data),
      modifiedByEid: getModifiedByEid(data),
      modifiedByFirstName: getModifiedByFirstName(data),
      modifiedByLastName: getModifiedByLastName(data),
    };
  }

  if (data.tempStation) {
    loggedInUserData.tempStation = data.tempStation;
  }

  console.log(`loggedInUserData: `, loggedInUserData);
  return loggedInUserData;
}

function isAdmin(role) {
  return role === ADMIN_ACCESS || role === MULTI_STATION_ADMIN_ACCESS;
}

export function getEmployeeActiveStation(data) {
  return data.activeStation;
}

export function getEmployeeHomeStation(data) {
  return data.homeStation;
}

export function getEmployeeJobCode(data) {
  return data.homeAccountJobCode;
}

export function getEmployeeFirstName(data) {
  // We deliberately give shortName here as this is the value we should use all throughout STARS
  return data.shortName;
}

export function getEmployeeLastName(data) {
  return data.lastName;
}

export function getEmployeeId(data) {
  return data.eid;
}
export function getFtPt(data) {
  return data.ftpt || "";
}

export function getPhoneNumber(data) {
  return data.phoneNumber || "";
}

export function getV(data) {
  return data.v;
}

export function getClassificationDate(data) {
  return data.classificationDate || "";
}

export function getContractDate(data) {
  return data.contractDate || "";
}

export function getWnSliSeniorityDate(data) {
  return data.wnSliSeniorityDate || "";
}

export function getFlAtlSeniorityDate(data) {
  return data.flAtlSeniorityDate || "";
}

export function getDualSeniorityDate(data) {
  return data.dualSeniorityDate || "";
}

export function getSeniorityDate(data) {
  return data.seniorityDate || "";
}

export function getHireDate(data) {
  return data.hireDate || "";
}

export function getBirthDate(data) {
  return data.birthDate || "";
}

export function getCreatedAt(data) {
  return data.createdAt;
}

export function getCreatedBy(data) {
  return data.createdBy;
}

export function getComments(data) {
  return data.comments || "";
}

export function getModifiedByEid(data) {
  return data.modifiedByEid || "";
}

export function getModifiedByFirstName(data) {
  return data.modifiedByFirstName || "";
}

export function getModifiedByLastName(data) {
  return data.modifiedByLastName || "";
}
